import { Box, Grid, Typography } from '@mui/material'
import { Container } from '@mui/system'
import React from 'react'
import { Button } from '@mui/material'
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import ImageID001 from '../../../file/Group823.svg'
import GroupID001 from '../../../file/GroupID001.png' 
import Group2 from '../../../file/Group871.png'
import Map from '../../../file/Map.png'
const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F7F7F9',
    ...theme.typography.body2,
    /*  padding: theme.spacing(1),  */
    color: theme.palette.text.secondary,
    boxShadow: 'none',
    minHeight: '100%',
    borderRadius: 20,
    position: 'relative'
}));
export default function BoxDialogID001() {
    return (
        <Box>
            <Container maxWidth="md" sx={{ marginTop: 7, padding: 0 }}>
                <Box sx={{ padding: 0 }}>
                    <Typography variant="h3" component="h3" sx={{ textTransform: 'uppercase', fontWeight: 600, opacity: 0.8 }} className=" divide-y ">
                        Covid19-Data-News
                    </Typography>
                    <Box sx={{ flexGrow: 1, marginTop: 5 }}>
                        <Grid container spacing={{ xs: 2, md: 2.5 }} columns={{ xs: 2, sm: 12, md: 12 }}>
                            <Grid item xs={3}>
                                <Box >
                                    <Typography variant="h7" component="h7" sx={{ textTransform: 'uppercase', fontWeight: 600, opacity: 0.5 }}>
                                        VAI TRÒ CỦA TÔI
                                    </Typography>
                                    <Typography sx={{ paddingTop: 0.5 , opacity: 0.9}}>
                                        Web Developer
                                    </Typography>
                                </Box>
                                <Box sx={{ marginTop: 2 }}>
                                    <Typography variant="h7" component="h7" sx={{ textTransform: 'uppercase', fontWeight: 600, opacity: 0.5 }}>
                                        Trách nhiệm
                                    </Typography>
                                    <Typography sx={{ paddingTop: 0.5, opacity: 0.9 }}>
                                        <ul >
                                            <li> Web design</li>
                                            <li> Build Front-end</li>
                                            <li> Build Back-end</li>
                                        </ul>
                                    </Typography>
                                </Box>
                                <Box sx={{ marginTop: 2 }}>
                                    <Typography variant="h7" component="h7" sx={{ textTransform: 'uppercase', fontWeight: 600, opacity: 0.5 }}>
                                        MỐC THỜI GIAN
                                    </Typography>
                                    <Typography sx={{ paddingTop: 0.5, opacity: 0.9 }}>
                                        Ngày 12 Tháng 7 Năm 2022
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={9}>
                                <Box>
                                    <Typography variant="h7" component="h7" sx={{ textTransform: 'uppercase', fontWeight: 600, opacity: 0.5 }}>
                                        MÔ TẢ
                                    </Typography>
                                    <Typography sx={{ paddingTop: 0.5 , opacity: 0.9}}>
                                        Một ứng dụng web phân tích dữ liệu về sự di chuyển của Covid-19, thông tin về Covid-19, tình trạng tiêm chủng, dữ liệu thống kê và so sánh dữ liệu về các trường hợp Covid-19, tử vong, nhiễm trùng, xét nghiệm ở tất cả các quốc gia, bản đồ các vùng dịch trên thế giới, tải xuống nguồn dữ liệu và cung cấp tin tức nóng hổi trên Covid-19, ...
                                    </Typography>
                                </Box>
                                <Box sx={{ marginTop: 4 }}>
                                    <a href="https://covid19-data-news.web.app/">

                                        <Button variant="outlined" sx={{
                                            width: '50%', borderRadius: 5, border: 2, borderColor: '#D3D3D3',  fontWeight: 'bold', color: '#000000', opacity: 0.8, ':hover': {
                                                bgcolor: '#B6CAE0',
                                                color: '#FFFFFF',
                                                borderColor: '#B6CAE0'
                                            },
                                            
                                        }} >
                                            Website

                                        </Button>
                                    </a>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Container>
            <Container maxWidth="xl" sx={{ marginTop: 7, padding: 0 }}>
                <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={{ xs: 2, md: 2.5 }} columns={{ xs: 2, sm: 12, md: 12 }}>
                        <Grid item xs={12} >
                            <Item sx={{
                                padding: 3, cursor: 'pointer'
                            }}>
                                <img src={ImageID001} alt="" className=' rounded-lg' />
                            </Item>
                        </Grid>
                        <Grid item xs={6} >
                            <Item sx={{
                                padding: 3, cursor: 'pointer',
                            }}>
                                <img src={GroupID001} alt="" className=' rounded-lg   items-center pt-[25%] w-full h-full' />
                            </Item>
                        </Grid>
                        <Grid item xs={6} >
                            <Item sx={{
                                padding: 3, cursor: 'pointer',
                            }}>
                                <img src={Group2} alt="" className=' rounded-lg' />
                            </Item>
                        </Grid>
                        <Grid item xs={12} >
                            <Item sx={{
                                padding: 3, cursor: 'pointer',
                            }}>
                                <img src={Map} alt="" className=' rounded-lg' />
                            </Item>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
        </Box>
    )
}
